<avano-panel [headerText]="translationKeys.dossierSummaryComponent.html.productDossier | translate">
  <ng-template avanoTemplate="summary">
    <div class="summary">
      <div class="summary-heading"><i class="icon-content-upload"></i></div>

      <div class="summary-container">
        <div class="summary-label">{{ translationKeys.dossierSummaryComponent.html.productName | translate }}</div>
        <div class="summary-value" scipSpacesAsIs>{{ product.name }}</div>
      </div>
      <div class="summary-container">
        <div class="summary-label">{{ translationKeys.dossierSummaryComponent.html.type | translate }}</div>
        <div class="summary-value">{{ product.type }}</div>
      </div>
      <div class="summary-container">
        <div class="summary-label">{{ translationKeys.dossierSummaryComponent.html.partNumber | translate }}</div>
        <div class="summary-value" scipSpacesAsIs>{{ productNode?.primaryArticleIdentifierValue }}</div>
      </div>
      <div class="summary-container">
        <div class="summary-label">{{ translationKeys.dossierSummaryComponent.html.lastDossierStatus | translate }}</div>
        <div class="summary-value" [scipSubmissionStatus]="product.scipDossierSubmissionStatus">
          {{ product.scipDossierSubmissionStatus | dossierStateTranslationKey | translate }}
        </div>
      </div>
    </div>
  </ng-template>
  <div class="readiness-header">
    {{ translationKeys.dossierSummaryComponent.html.scipReadinessLabel | translate }}
  </div>
  <div class="form-field">
    <input readonly id="dossier_name" avanoInputText [value]="product.dossierName" [label]="translationKeys.dossierSummaryComponent.html.dossierNameLabel | translate"/>
  </div>
  <div class="form-field">
    <input readonly id="dossier_remark" avanoInputText [value]="product.dossierRemarks" [label]="translationKeys.dossierSummaryComponent.html.dossierRemarkLabel | translate" />
  </div>
</avano-panel>
